import { render, staticRenderFns } from "./CarBookingInvoice.vue?vue&type=template&id=c6ec15e4&"
import script from "./CarBookingInvoice.vue?vue&type=script&lang=ts&"
export * from "./CarBookingInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports